import { Component, forwardRef, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { IOption } from '../models/option';
import { RadioButtonLayoutDirection } from './radio-group-constants';

@Component({
    selector: 'app-radio-group',
    templateUrl: './radio-group.component.html',
    styleUrl: './radio-group.component.scss',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => RadioGroupComponent),
            multi: true
        }
    ],
    standalone: false
})
export class RadioGroupComponent implements ControlValueAccessor {

  @Input('value') _value: any;
  @Input() id?: string = 'radio';
  @Input() name: string = 'radioGroup';
  @Input() label: string | undefined;
  @Input() loading: boolean = false;
  @Input() options: IOption<any>[] = [];
  @Input() layoutDirection: RadioButtonLayoutDirection = RadioButtonLayoutDirection.Horizontal;

  RadioButtonLayoutDirection = RadioButtonLayoutDirection; // Expose enum to template

  onChange: any = () => {
   };
  onTouched: any = () => { };

  get value() {
    return this._value;
  }

  set value(val) {
    this._value = val;
    this.onChange(val);
    this.onTouched();
  }

  constructor() {
  }

  writeValue(value: any): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  generateId(option: IOption<any>): string {
    return this.name + '-' + option.value.toString().replace(/\s+/g, '-').toLowerCase();
  }

}
